import get from 'lodash.get';

export const filterPersonalizationItems = items => {
    return items.filter(item => get(item, 'node.items', []).length);
};
